import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
import { appFetch } from 'src/lib/appFetch';

const fetchApi = async <T = unknown>(endpoint: string, options: RequestInit = {}) => {
  return appFetch(endpoint, options) as T;
};

export const useLogin = () => {
  const client = useQueryClient();

  return useCallback(
    async (token: string) => {
      const result = await appFetch('/users/login', {
        method: 'POST',
        body: JSON.stringify({ token }),
      });
      // Signing in on the way to an OAuth consent page (an MCP client connecting): continue there.
      if (result.return_to) {
        window.location.assign(result.return_to);
        return;
      }
      await client.invalidateQueries({ queryKey: ['me'] });
    },
    [client]
  );
};

export const useLogout = () => {
  const client = useQueryClient();

  return useCallback(async () => {
    await appFetch('/users/logout', {
      method: 'POST',
    });
    await client.invalidateQueries({ queryKey: ['me'] });
  }, [client]);
};

export default fetchApi;
